export function animationOnScroll() {
    let $window = $(window);
    let $items = $(".has-animation");

    function startAnimate() {
        $items.each(function (i, it) {
            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.88) {
                $(it).addClass("animated");
                if ($(".circle.has-animation").closest(".hero-section")) {
                    setTimeout(() => {
                        $(".hero-image").removeClass("has-animation");
                    }, 1000);
                }
            }
        });
    }

    startAnimate();

    $window.on("scroll load", function () {
        startAnimate();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animationOnScroll.js